import { 
	createSlice,
	createSelector,
	createAsyncThunk,
	createEntityAdapter
} from '@reduxjs/toolkit'
import {envAwarePost} from '../../util/util'

export const getScheduledMessages = createAsyncThunk(
	'getScheduledMessages',
	async ()=>{
		//the api call defaults to getting upcoming messages
		const {
			success:upcomingSuccess,
			message:upcomingMessage,
			data:upcomingMessages
		} = await envAwarePost('api/messaging/api/',{
			action: 'getScheduledMessages',
		})
		//get previous api calls
		const {
			success:previousSuccess,
			message:previousMessage,
			data:previousMessages
		} = await envAwarePost('api/messaging/api/',{
			action: 'getScheduledMessages',
			get_previous:1
		})
		if(previousSuccess==='1') previousMessages.forEach( m => { m.isPast = true } )
		const success = previousSuccess === '1' && upcomingSuccess === '1' ? '1' : '0'
		const message = `${upcomingMessage}, ${previousMessage}`
		const data = [
			...upcomingMessages,
			...previousMessages
		]
		return {success,message,data}
	}
)

export const deleteScheduledMessage = createAsyncThunk(
	'deleteScheduledMessage',
	async message_id => envAwarePost('api/messaging/api.php',{
		action: 'deleteScheduledMessage',
		message_id
	})
)

export const editScheduledMessage = createAsyncThunk(
	'editScheduledMessage',
	async payload => envAwarePost('api/messaging/api.php',{
		action: 'editScheduledMessage',
		...payload
	})
)

const scheduledMessagesAdapter = createEntityAdapter()

const messengerSlice = createSlice({
	name: 'messenger',
	initialState:{
		editor:{
			show:false,
			status:'idle',
			//only matters if mode show is true
			messageId:null
		},
		scheduledMessages:scheduledMessagesAdapter.getInitialState()
	},
	reducers: {
		hideEditor: state => {
			state.editor.show = false
		},
		editMessage : (state,action) => {
			state.editor.show = true	
			state.editor.messageId = action.payload
		},
		newMessageScheduled : (state,action) => {
			scheduledMessagesAdapter.addOne(state.scheduledMessages,action.payload)
		}
	},
	extraReducers:{
		[getScheduledMessages.fulfilled] : (state,action)=>{
			const {success,data} = action.payload
			if(success === '1') scheduledMessagesAdapter.upsertMany(state.scheduledMessages,data)
		},
		[deleteScheduledMessage.pending] : (state,action)=>{
			const {arg:id} = action.meta
			scheduledMessagesAdapter.removeOne(state.scheduledMessages,id)
		},
		[editScheduledMessage.pending] : state => {
			state.editor.status = 'loading'
		},
		[editScheduledMessage.fulfilled] : (state,action)=>{
			state.editor.status = 'idle'
			const {success,data} = action.payload
			if(success === '1') scheduledMessagesAdapter.updateOne(state.scheduledMessages,{
				id:data.id,
				changes:data.message
			})
		}
	}
})

export const {
	newMessageScheduled,
	hideEditor,
	editMessage
} = messengerSlice.actions

// Export the customized selectors for this adapter using `getSelectors`
export const {
	selectAll: selectAllScheduledMessages,
	selectById: selectScheduledMessageById,
	selectIds: selectScheduledMessagesIds
} = scheduledMessagesAdapter.getSelectors(state => state.messenger.scheduledMessages)

export const selectUpcomingMessages = createSelector(
	selectAllScheduledMessages,
	scheduledMessages => scheduledMessages.filter(c=>!c.isPast)
)
export const selectPastMessages = createSelector(
	selectAllScheduledMessages,
	scheduledMessages => scheduledMessages.filter(c=>c.isPast)
)


export default messengerSlice.reducer